import type { SyncActivityRecord } from "~/helpers/sw/messageContract";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SyncActivityState {
	records: SyncActivityRecord[];
}

export interface SyncActivityRootState {
	syncActivity: SyncActivityState;
}

const initialState: SyncActivityState = { records: [] };

export const syncActivitySlice = createSlice({
	initialState,
	name: "syncActivity",
	reducers: {
		setSyncActivity: (state, action: PayloadAction<SyncActivityRecord[]>) => {
			state.records = action.payload;
		}
	}
});

export const { setSyncActivity } = syncActivitySlice.actions;

export const selectSyncActivityRecords = (state: SyncActivityRootState): SyncActivityRecord[] =>
	state.syncActivity.records;

export default syncActivitySlice.reducer;
